<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCptipoembalaje" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Descripción</label>
							<input type="text" v-model="objCpTipoEmbalaje.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripción" />
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpTipoEmbalaje.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCptipoembalaje',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpTipoEmbalaje: {
				IdTipoEmbalaje: 0,
				Descripcion: '',
				Clave: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpTipoEmbalaje.IdTipoEmbalaje == 0) {
				await this.$http.post(
					'cpTiposEmbalaje',this.objCpTipoEmbalaje
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpTiposEmbalaje/'+this.objCpTipoEmbalaje.IdTipoEmbalaje,
					this.objCpTipoEmbalaje
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpTiposEmbalaje/"+this.objCpTipoEmbalaje.IdTipoEmbalaje
            ).then((res) => {
                this.objCpTipoEmbalaje = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpTipoEmbalaje.Fecha.replace(/-/g,'\/');
                this.objCpTipoEmbalaje.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpTipoEmbalaje = {
				IdTipoEmbalaje: 0,
				Descripcion: '',
				Clave: ''
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpTipoEmbalaje.IdTipoEmbalaje = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
